import { Loader } from "@design-system/Loader/Loader";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import invoiceStyles from "@components/invoices/NativeInvoiceDrawer/NativeInvoiceDrawer.module.scss";

export const LayoutEditorLoadState = ({
    isPending,
    onRetry,
}: {
    isPending: boolean;
    onRetry: () => void;
}) => (
    <div className={invoiceStyles.workspace}>
        <div className={invoiceStyles.loadingState}>
            {isPending ? (
                <Loader />
            ) : (
                <EmptyState
                    header="Couldn't load report settings"
                    ctaText="Retry"
                    action={onRetry}
                />
            )}
        </div>
    </div>
);
